import script from "./PrivacySection.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacySection.vue?vue&type=script&setup=true&lang=js"

import "./PrivacySection.vue?vue&type=style&index=0&id=0ed7f0bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ed7f0bc"]])

export default __exports__